import React from 'react';
import Card from '../../Controls/Card';
import ResultsScene from '../ResultsScene';
export default class Render extends React.Component {
  state = {
    appear: false,
    expand: true
  };
  componentDidUpdate(prevProps) {
    if (prevProps.step < 4 && this.props.step >= 4) {
      this.setState({ appear: true });
    }
    if (prevProps.step >= 4 && this.props.step < 4 && !this.props.scrolling) {
      // this.setState({ appear: false });
    }
  }

  render() {
    const { appear, expand } = this.state;

    const {
      configuration,
      step,
      handleScrollIn,
      handleScrollOut,
      handleStepSet,
      disableWaypoint
    } = this.props;
    return (
      <Card
        stepIndex={4}
        disableWaypoint={disableWaypoint}
        step={this.props.step}
        handleStepSet={handleStepSet}
        maxHeight={650}
        expand={expand}
        appear={appear}
        handleScrollIn={this.props.step === 4 ? handleScrollIn : () => {}}
        handleScrollOut={this.props.step === 3 ? handleScrollOut : () => {}}
        header={'3D Scene'}
        cardComponentStyle={{
          height: 650,
          margin: '40px 0 0',
          padding: 0,
          alignItems: 'flex-start',
          alignContent: 'flex-start'
        }}
        content={<ResultsScene configuration={configuration} />}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Results/Scene/index.js